import { useEffect, useState } from 'react';
import { useAuth } from './useAuth';
import { interpretersService, InterpreterRow } from '../services/interpretersService';

interface InterpreterState {
  interpreter: InterpreterRow | null;
  loading: boolean;
}

export function useInterpreter() {
  const { user } = useAuth();
  const [state, setState] = useState<InterpreterState>({
    interpreter: null,
    loading: true
  });

  useEffect(() => {
    if (!user?.email) {
      setState({ interpreter: null, loading: false });
      return;
    }

    const checkInterpreterStatus = async () => {
      try {
        const interpreter = await interpretersService.getByEmail(user.email);
        setState({ interpreter, loading: false });
      } catch (error) {
        console.error('Error checking interpreter status:', error);
        setState({ interpreter: null, loading: false });
      }
    };

    checkInterpreterStatus();
  }, [user]);

  return state;
}

